// extracted by mini-css-extract-plugin
export default {"content":"Contact_content__Vw63t","intro":"Contact_intro__Hr92a","links":"Contact_links__jdYkD"};